import React from 'react';
import { Box, Typography, Container, Grid, Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import WbButton from '../../components/common/WbButton';
import WbLoader from '../../components/common/WbLoader';
import KioskLayout from '../../components/kiosk/KioskLayout';
import { useKiosk } from '../../contexts/KioskContext';
import { parentMode, studentMode, iconExit } from '../../components/assets/images';
import paths from '../../routes/paths';
import './KioskStyles.scss';


export default function AdminSetup() {
  const { schoolSlug } = useParams();
  const { school, loading, exitKiosk, setKioskMode, mode } = useKiosk();
  const navigate = useNavigate();

  const handleModeSelect = (mode) => {
    setKioskMode(mode, false);
  };

  const handleExit = () => {
    exitKiosk();
  };

  if (loading) {
    return (
      <KioskLayout>
        <WbLoader />
      </KioskLayout>
    );
  }

  return (
    <KioskLayout>
      <Container maxWidth="md">
        <Box className="kiosk-card">          
          {mode && (
            <Alert severity="success">Current Mode: <strong>{mode} Mode</strong></Alert>           
          )}

          <Grid container spacing={2} justifyContent="center" alignItems="center" mt={0.5}>

          
            {/* <WbButton
              CustomButtonText="Parent Mode"
              onClick={() => handleModeSelect('Parent')}
              className="kiosk-button-large"
            /> */}
            <Grid item xs={12} sm={6} md={6}> 
              <div className='student-mode' onClick={() => handleModeSelect('Student')}>
                <div className='student-img-mode'>
                  <img src={studentMode} alt="Student Mode" />
                </div>
                <span>Student Mode</span>              
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <div className='parent-mode' onClick={() => handleModeSelect('Parent')}>
                <div className='parent-img-mode'>
                  <img src={parentMode} alt="Parent Mode" />
                </div>
                <span>Parent Mode</span>              
              </div>
            </Grid>


            {/* <WbButton
              CustomButtonText="Student Mode"
              onClick={() => handleModeSelect('Student')}
              className="kiosk-button-large"              
            /> */}
          </Grid>

          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <WbButton
              CustomButtonText="Exit Kiosk"
              onClick={handleExit}
              className="kiosk-button-secondary"              
              startIcon={<img src={iconExit} alt="Exit Kiosk" />}
            />
          </Box>
        </Box>
      </Container>
    </KioskLayout>
  );
}
